import { useEffect } from 'react'
import { connect } from 'react-redux'
import withStateReadyCheck from '../../withStateReadyCheck'
import { trackPageView, trackView } from '../../store/modules/tracking/tracking'

const TrackingLoader = ({ onLoad }) => {
  useEffect(() => {
    if (window && window.kitFunction && window.kitFunction.listing && typeof window.kitFunction.listing.getListingsIds === 'function') {
      window.kitFunction.listing
        .getListingsIds()
        // SUCCESS: a new listing is returned or an empty array
        .then(() => {
          onLoad({ referrer: document.referrer, location: document.location, isConnected: true })
        })
        .catch(() => {
          onLoad({ referrer: document.referrer, location: document.location, isConnected: false })
        })
    } else {
      onLoad({ referrer: document.referrer, location: document.location })
    }
  }, [])
  return null
}

const mapDispatchToProps = dispatch => ({
  onLoad: data => {
    dispatch(trackView(data))
    dispatch(trackPageView(data))
  },
})

export default withStateReadyCheck(
  connect(
    null,
    mapDispatchToProps,
  )(TrackingLoader),
)
